import { SuperAdminConstants } from '../../../_constants';

const initialState = { addOrgAdminLoading: true, data: '', error: false };

export function addOrgAdminReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ADD_ORG_ADMINS:
            return {
                addOrgAdminLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ADD_ORG_ADMINS:
            return {
                addOrgAdminLoading: false,
                data: action.addOrgAdmin,
                error: false
            };
        case SuperAdminConstants.ADD_ORG_ADMINS_ERROR:
            return {
                addOrgAdminLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageOrgAdmins/addOrgAdmin.reducer.js